export const validaData = (value) => {
  if (!value) return false
  try {
    const [hora, minuto] = value.split(':').map((e) => parseInt(e))
    return hora >= 0 && hora < 24 && minuto >= 0 && minuto < 60
  } catch (e) {
    return false
  }
}
